import React from 'react'

import { Portlet, Row, Col } from '_zari/core'

import * as Sections from './sections'

const ReportesPortlet = ({ tablaRef }) => {
  return (
    <Portlet>
      <Portlet.Header title='Reportes detracción' />
      <Portlet.Body>
        <Row>
          <Col md={6}>
            <Sections.ReporteExcelSection />
          </Col>
          <Col md={6}>
            <Sections.ReporteTxtSection tablaRef={tablaRef} />
          </Col>
        </Row>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(ReportesPortlet)
